import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IProfileJobInfo } from '../../../../interfaces/telephony/profile-job-info';
import { CustomerService, JobsService } from '../../../../services';
import { IGetProfileOrdersFilter } from '../../../../interfaces/telephony/customer/get-profile-orders-filter.interface';

@Component({
  selector: 'customer-profile-all-jobs',
  templateUrl: './customer-profile-all-jobs.component.html',
  styleUrls: ['./customer-profile-all-jobs.component.scss'],
})
export class CustomerProfileAllJobsComponent implements OnInit, OnDestroy {
  @Input() customerId: number;

  constructor(private customerService: CustomerService) {}

  jobs: IProfileJobInfo[];
  isBusy = false;

  private searchSubject: Subject<string> = new Subject();
  searchText: string;

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchText) => {
      this.searchJobs(searchText);
    });
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

  searchJobs(text: string) {
    const filter = {
      customerId: this.customerId,
      searchReg: text,
    } as IGetProfileOrdersFilter;

    // load all organisation information once on start
    this.isBusy = true;
    this.customerService
      .getProfileOrders(filter)
      .then((res) => {
        this.jobs = res;
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      });
  }

  searchTextChanged(text: string): void {
    text = text || '';
    this.searchText = text;

    if (this.searchText.length >= 3) {
      this.searchSubject.next(this.searchText);
    }
  }

  resetVrm() {
    this.searchText = '';
    this.jobs = [];
  }
}
